<template>
  <div style="width: 100%; height: 100%">
    <!-- 礼包中心弹窗 -->
    <GiftDialog v-if="showGiftDialog" ref="dialog" @refreshHome="refreshHome" />
    <!-- yy496 新增，引流弹窗 -->
    <LeadGiftDialog ref="leadDialog" :pageType="1" />
    <div :class="$style.box" ref="box">
      <div :style="{ backgroundImage: `url(${topBgImg})` }">
        <!-- 返回箭头 -->
        <div :class="$style.back" @click="back">
          <img :src="backImg" alt />
        </div>
        <!-- 广告轮播图 -->
        <BannerSwiper ref="banner" :class="$style.banner"></BannerSwiper>
        <!-- 绑定、注销游戏账号 -->
        <section :class="`${$style['login-cell']}`">
          <van-cell :class="$style['login-cell-item']" style="padding: 0">
            <template slot="title">
              <div>
                <img :src="userIcon" width="14px" />
                <span v-if="isBindAccount" style="margin-left: 4px">欢迎您，</span>
                <span v-if="isBindAccount" style="color: rgb(255, 126, 48)">{{
                  userInfo.game_account
                }}</span>
                 <!--  -->
                <span v-if="isBindAccount" class="ml_8 color_link" @click="bindAccount">切换账号</span>
                <span v-else style="margin-left: 4px">绑定游戏账号</span>
              </div>
            </template>
            <template slot="right-icon">
              <!-- <div @click="handleLogout">
                <span>注销</span>
                <Icon
                  style="position: relative; top: 1px; margin-left: 2px; font-size: 12px"
                  name="arrow"
                ></Icon>
              </div> -->
              <div v-if="!isBindAccount" @click="bindAccount">
                <span>点我绑定</span>
                <van-icon
                  style="position: relative; top: 1px; margin-left: 2px; font-size: 12px"
                  name="arrow"
                ></van-icon>
              </div>
            </template>
          </van-cell>
        </section>

        <!-- PT087新增活动导航区 -->
        <div :class="$style['activity-nav']">
          <div
            v-for="(activityItem, activityIndex) in activityConfig"
            :key="`activity-${activityIndex}-${activityItem.name}`"
            :class="$style['activity-nav-item']"
            @click="openActivityContent(activityItem)"
          >
            <img :src="activityItem.images" :alt="activityItem.name" />
            <p>{{ activityItem.name }}</p>
          </div>
        </div>

        <!-- 已激活游戏 -->
        <CircleBaseBox
          boxTitle="已激活游戏"
          headerRightText="我的礼包"
          @clickRightIcon="handleLinkTo('personalCenter.myGift')"
        >
          <div v-if="!isBindAccount" :class="$style['game-not-show']">
            <div :class="$style.word">
              您当前未绑定游戏账号，绑定后，即可查看已激活游戏下的礼包！
            </div>
            <div :class="$style.toBind" @click="bindAccount">点击前往绑定</div>
            <img :src="catBack" alt />
          </div>
          <div v-if="isBindAccount && hasActivatedGameList">
            <swiper :class="$style['active-game-list']" :options="swiperOption">
              <swiper-slide
                v-for="item of activatedGameList"
                :key="item.id"
                :class="$style['active-game-item']"
                @click.native="handleLinkTo('giftCenter.activatedGame', { gameId: item.id })"
              >
                <img :src="item.images" />
                <p>{{ item.name }}</p>
                <div>
                  <img :src="giftIcon" width="9px" height="9px" />
                  <div>礼包数{{ item.count }}</div>
                </div>
              </swiper-slide>
            </swiper>
          </div>
          <div :class="$style['game-not-show']" v-if="isBindAccount && !hasActivatedGameList">
            <div :class="$style.word">您当前未激活游戏，下载一款游戏并进入，即可激活！</div>
            <div :class="$style.toBind" @click="handleLinkTo('gameCenter.home')">
              点我去游戏中心逛逛
            </div>
            <img :src="catBack" alt />
          </div>
        </CircleBaseBox>
        <div :class="$style.tabs">
          <span :class="[plate_type==1 ? $style.active : '']" @click="changeType(1)">专属礼包</span>
          <span :class="[plate_type==2 ? $style.active : '']" @click="changeType(2)">限时福利</span>
          <span :class="[plate_type==3 ? $style.active : '']" @click="changeType(3)">直播专享福利</span>
        </div>
        <!-- 板块一 -->
        <CircleBaseBox
          v-if="Object.keys(firstGiftPlate).length"
          :boxTitle="firstGiftPlate.name"
          headerRightText="全部礼包"
          @clickRightIcon="handleLinkTo('giftCenter.allGift', { plateId: firstGiftPlate.id })"
          @click.native="
            () => {
              firstGiftPlate.id && plateReport(firstGiftPlate.id);
            }
          "
        >
          <HorLayout
            v-if="firstGiftPlate.arrangement == 1"
            :plateId="firstGiftPlate.id"
            :swiperList="firstGiftPlate.gift_sets"
          />
          <VerLayout v-else :plateId="firstGiftPlate.id" :swiperList="firstGiftPlate.gift_sets" />
        </CircleBaseBox>
        <!-- 礼包上新 -->
        <!-- <CircleBaseBox
          boxTitle="礼包上新"
          headerRightText="全部礼包"
          @clickRightIcon="handleLinkTo('giftCenter.allGift')"
        >
          <VerLayout :swiperList="giftNewList" />
        </CircleBaseBox> -->
        <!-- 其他板块 -->
        <section v-if="remainGiftPlates.length">
          <CircleBaseBox
            v-for="plateItem of remainGiftPlates"
            :key="plateItem.id"
            :boxTitle="plateItem.name"
            headerRightText="全部礼包"
            @clickRightIcon="handleLinkTo('giftCenter.allGift', { plateId: plateItem.id })"
            @click.native="
              () => {
                plateItem.id && plateReport(plateItem.id);
              }
            "
          >
            <HorLayout
              v-if="plateItem.arrangement == 1"
              :swiperList="plateItem.gift_sets"
              :plateId="plateItem.id"
            />
            <VerLayout v-else :swiperList="plateItem.gift_sets" :plateId="plateItem.id" />
          </CircleBaseBox>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import BannerSwiper from './components/BannerSwiper';
import CircleBaseBox from '_c/CircleBaseBox';
import HorLayout from './components/HorLayout';
import VerLayout from './components/VerLayout';
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import GiftDialog from './components/GiftDialog';
import { Cell, Icon, Toast, Dialog } from "vant";
import { getActivatedGame, getGiftPlate, getNewGift, getNavigationData } from '@/api/giftCenter';
import { reportData } from '@/api/report';
import { cancelGameAccount } from '@/api/account';
import { CDN_URL } from "@/config/index.js";
import { mapActions, mapState, mapMutations } from "vuex";
import { localLinkJump } from '@/utils/index.js';
import 'swiper/css/swiper.css'
import bindAccountMixin from '@/mixins/bindAccountMixin.js'
import bottomNavigationMixin from '@/mixins/bottomNavigationMixin.js';
import LeadGiftDialog from '_c/LeadGiftDialog'
let vm = ''
export default {
  mixins: [bindAccountMixin, bottomNavigationMixin],
  components: {
    CircleBaseBox,
    BannerSwiper,
    Swiper,
    SwiperSlide,
    HorLayout,
    VerLayout,
    GiftDialog,
    Toast,
    VanCell: Cell,
    VanIcon: Icon,
    LeadGiftDialog,
  },
  data() {
    return {
      backImg: `${CDN_URL}/gameCenter/back.png`, // 返回按钮图片
      topBlankBgImg: `${CDN_URL}/gameCenter/blank_bg.png`, // 顶部空白背景图
      topBgImg: `${CDN_URL}/gameCenter/gift_bg.png`, // 顶部背景图
      catBack: `${CDN_URL}/catBack.png?v=123`,
      userIcon: `${CDN_URL}/gift_center/userone.png`, // 用户小图标
      giftIcon: `${CDN_URL}/gift_center/giftone.png`, // 礼物小图标
      activatedGameList: [], // 激活游戏
      giftPlatesList: [], // 所有配置礼包板块
      firstGiftPlate: {}, // 第一个礼包板块
      remainGiftPlates: [], // 剩余板块数组
      giftNewList: [], // 上新板块下的礼包列表
      swiperOption: {
        slidesPerView: 4.7,
        spaceBetween: 18,
        grabCursor: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
      },
      scrollY: 0,
      showGiftDialog: true,
      plate_type: 1,

      // 活动导航区的配置信息
      activityConfig: []
    };
  },
  watch: {
    isBindAccount(newValue) {
      if (newValue) {
        this.getActivatedGame()
      }
    },
    userInfo: {
      handler(val, oldVal) {
        if (!val || !val.game_account) return;
        this.$refs.leadDialog.initData();
      },
      deep: true,
    },
  },
  created() {
    vm = this
    this.getActivatedGame()
    this.getGiftPlate()
    this.getNewGift()
    this.getActivityNavData()
  },
  mounted() {
    const { type } = this.$route.query;
    this.plate_type = type || 1;
    reportData({
      type: 10,
      data_type: 8,
      plate_type: this.plate_type
    })
    this.$refs.leadDialog.initData();
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (vm.$refs.box) {
        vm.$refs.box.scrollTop = vm.scrollY;
      }
    })
  },
  beforeRouteLeave(to, from, next) {
    if (this.$refs.box) {
      this.scrollY = this.$refs.box.scrollTop;
    }
    next();
  },
  activated() {
    reportData({
      type: 10,
      data_type: 1
    })
    this.showGiftDialog = true
    this.refreshHome()
  },
  deactivated() {
    this.showGiftDialog = false
  },
  methods: {
    ...mapMutations('app', {
      CHANGE_SHOW_LOADING: 'CHANGE_SHOW_LOADING',
      CHANGE_BOTTOM_NAV_ARRAY: 'CHANGE_BOTTOM_NAV_ARRAY',
    }),
    ...mapActions("account", {
      getUserInfo: "getUserInfo"
    }),
    changeType(type) {
      reportData({
        type: 10,
        data_type: 8,
        plate_type: type
      })
      this.plate_type = type;
      this.getGiftPlate()
      this.getNewGift()
    },
    // 获取已激活游戏列表
    async getActivatedGame() {
      const r = await getActivatedGame()
      this.activatedGameList = [...r.data.result]
    },
    // 获取可配置板块列表
    async getGiftPlate() {
      const r = await getGiftPlate({ plate_type: this.plate_type })
      this.giftPlatesList = [...r.data]
      if (!this.giftPlatesList.length) {
        this.firstGiftPlate = []
        this.remainGiftPlates = []
        return
      }
      this.firstGiftPlate = this.giftPlatesList[0]
      if (this.giftPlatesList.length == 1) {
        this.remainGiftPlates = []
        return
      }
      this.remainGiftPlates = this.giftPlatesList.slice(1)
    },
    // 获取上新列表
    async getNewGift() {
      const r = await getNewGift({ plate_type: this.plate_type })
      this.giftNewList = [...r.data]
    },
    // 点击返回按钮
    back() {
      this.$router.go(-1);
    },
    // 用户绑定
    bindAccount() {
      this.CHANGE_BIND_ACCOUNT_DIALOG(this.isBindAccount ? {
        visible: true,
        isSwitchAccount: true,
      } : true)
    },
    onChangeAccount () {
      this.refreshHome()
    },
    // 用户注销
    async handleLogout() {
      Dialog.confirm({
        title: '确认注销账号？',
      }).then(async () => {
        this.CHANGE_SHOW_LOADING(true)
        const r = await cancelGameAccount()
        this.getUserInfo()
        setTimeout(() => {
          this.CHANGE_SHOW_LOADING(false)
        }, 0);
      }).catch(() => { });
    },
    // 点击已激活游戏列表
    handleActivatedGame(id) {
      this.$router.push({ name: 'giftCenter.activatedGame', params: { id } })
    },
    // 路由跳转
    handleLinkTo(name, query) {
      if (name === 'giftCenter.allGift') {
        reportData({
          type: 10,
          data_type: 4
        })
      }
      this.$router.push({ name, query })
    },
    // 重新获取礼包数据
    refreshHome() {
      this.getGiftPlate()
      this.getNewGift()
    },
    async openActivityContent(activityItem) {
      if (!activityItem || !activityItem.url) return;
      const targetUrl = String(activityItem.url).trim();
      if (!targetUrl) return;
      await this.reportActivityNavigation(activityItem);
      // 跳转链接
      this.$router.push({
        name: 'giftCenter.activityBridge',
        query: {
          name: activityItem.name || '',
          url: targetUrl,
          jumpType: 'activity',
        },
      })
      return;
      // if (activityItem.url_type == 2) {
      // }
      // localLinkJump(targetUrl)
    },
    findCurrentPageNavigation(navList = this.bottomNavArray) {
      if (!Array.isArray(navList)) return {};
      const sortedNavList = navList.slice().reverse();
      const currentPath = this.getCurrentRoutePath();
      const firstLevelItem = sortedNavList.find(
        item => Number(item.level) === 1 && this.isSameNavigationRoute(item.url, currentPath),
      );
      if (firstLevelItem) return firstLevelItem;
      const secondLevelItem = sortedNavList.find(
        item => Number(item.level) === 2 && this.isSameNavigationRoute(item.url, currentPath),
      );
      return secondLevelItem || {};
    },
    async getReportPageNavigation() {
      const currentPageNavigation = this.findCurrentPageNavigation();
      if (currentPageNavigation.id || currentPageNavigation.name) {
        return currentPageNavigation;
      }
      try {
        const r = await getNavigationData({ type: 1 });
        const bottomNavList = Array.isArray(r.data) ? [...r.data] : [];
        this.CHANGE_BOTTOM_NAV_ARRAY(bottomNavList);
        return this.findCurrentPageNavigation(bottomNavList);
      } catch (error) {
        console.log(error);
      }
      return {};
    },
    async reportActivityNavigation(activityItem) {
      try {
        const pageNavigation = await this.getReportPageNavigation();
        await reportData({
          type: 27,
          data_type: 2,
          navigation_id: activityItem.id || '',
          navigation_name: activityItem.name || '',
          page_id: pageNavigation.id || '',
          page_name: pageNavigation.name || '',
        });
      } catch (error) {
        console.log(error);
      }
    },
    plateReport(plateId) {
      if (plateId) {
        reportData({
          type: 10,
          data_type: 7,
          gift_plate_id: plateId
        })
      }
    },

    // 获取活动导航区数据
    async getActivityNavData() {
      const r = await getNavigationData({ type: 3 })
      this.activityConfig = [...r.data]
    }
  },
  computed: {
    ...mapState("account", {
      userInfo: state => state.userInfo // 当前用户信息
    }),
    ...mapState("app", {
      bottomNavArray: state => state.bottomNavArray,
    }),
    // 判断是否绑定游戏账号
    isBindAccount() {
      let flag = this.userInfo.game_user_id != 0 ? true : false
      return flag;
    },
    hasActivatedGameList() {
      return this.activatedGameList.length
    },
  },
};
</script>

<style lang="scss" module>
@import '~@/styles/mixins.scss';
.box {
  position: relative;
  height: 99.5vh;
  padding-bottom: 10px;
  overflow-y: scroll;
  background-color: #efefef;
  > div {
    position: relative;
    z-index: 10;
    background-repeat: no-repeat;
    background-size: 100%;
    .back {
      width: 40px;
      height: 33px;
      padding: 8px 0px 0px 10px;
      > img {
        width: 20px;
        height: 20px;
      }
    }
    .banner {
      margin-top: 30px;
      width: 100%;
      height: 160px;
    }
  }
  .login-cell {
    padding: 4px 10px 4px 10px;
    margin: 12px 10px 10.7px 10px;
    background-color: #fff;
    box-shadow: 0px 0px 7px 0px rgba(0, 0, 0, 0.03);
    border-radius: 7px;
    .login-cell-item {
      font-size: 10px;
      color: #969799;
      div {
        display: flex;
        align-items: center;
      }
    }
  }
  .activity-nav {
    width: 360px;
    margin: 0 auto 10px;
    padding: 10px 8px;
    display: flex;
    flex-wrap: wrap;
    row-gap: 8px;
    box-sizing: border-box;
    background-color: #fff;
    border: 1px solid #f2f2f2;
    border-radius: 8px;
    .activity-nav-item {
      width: 25%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      > img {
        width: 39px;
        height: 38px;
        object-fit: cover;
      }
      > p {
        margin-top: 6px;
        width: 100%;
        padding: 0 4px;
        font-size: 12px;
        line-height: 16px;
        color: #333;
        text-align: center;
        @include ellipsis(1);
        box-sizing: border-box;
      }
    }
  }
  .game-not-show {
    width: 340px;
    height: 101px;
    margin-top: 10px;
    position: relative;
    .word {
      width: 100%;
      line-height: 20px;
      text-align: center;
      font-size: 11px;
      color: #d1d1d1;
    }
    .toBind {
      position: absolute;
      width: 100px;
      height: 25px;
      border: 1px solid rgba(69, 175, 243, 1);
      border-radius: 12px;
      font-size: 10px;
      color: rgba(69, 175, 243, 1);
      line-height: 25px;
      text-align: center;
      top: 30px;
      left: 50%;
      transform: translateX(-50%);
    }
    > img {
      width: 301px;
      margin: 14px 0px 0px 16px;
    }
  }
  .active-game-list {
    margin-top: 6.5px;
    margin-left: 8px;
    .active-game-item {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      font-size: 10px;
      > img {
        width: 58px;
      }
      > p {
        @include ellipsis(1);
        width: 65px;
        margin-top: 6px;
        text-align: center;
        line-height: 12.5px;
      }
      > div {
        margin-top: 3.5px;
        width: 65px;
        font-size: 8px;
        color: rgb(255, 126, 48);
        position: relative;
        & > img {
          position: absolute;
          top: 2px;
          left: 4px;
        }
        & > div {
          @include ellipsis(1);
          padding-left: 15px;
          width: 65px;
          display: inline-block;
          height: 12px;
          line-height: 12px;
        }
      }
    }
  }
  .tabs {
    background-color: #FFFFFF;
    width: 360px;
    border-radius: 4px;
    margin: auto;
    height: 40px;
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    padding: 0 8px;
    > span {
      border: 1px solid #2FBAFE;
      text-align: center;
      display: inline-block;
      padding: 5px 14px;
      border-radius: 50px;
      color: #2FBAFE;
      font-size: 14px;
      &.active {
        background-color: #2FBAFE;
        color: #FFFFFF;
      }
    }
    > span + span {
      margin-left: 8px;
    }
  }
}
</style>
